<template>
  <div :class="wrapperClass">
    <div class="pr-1">&nbsp;&nbsp;&nbsp;&nbsp;</div>
    <div class="input-table-shadow">
      <div class="d-flex row align-items-right">
        <div class="col-6"></div>
        <div class="col-1">Backup:</div>
        <div class="col-1 ml-3" v-click-outside="outsideAddCodeSearch">
          <input
            type="text"
            :placeholder="$t('travels.navigation.design.service-backup-code')"
            @click="toggleAddCodeSearch"
            v-model="backupLink.service.code"
          >
          <core-paginated-drop-down
            v-if="serviceTypes.length && showAddCodeSearch"
            :filters="serviceTypes"
            searchProperty="code"
            filterPropertyName="serviceTypeId"
            :item.sync="backupLink.service"
          ></core-paginated-drop-down>
        </div>
        <div class="col" v-click-outside="outsideAddNameSearch">
          <input
            type="text"
            :placeholder="$t('travels.navigation.design.service-backup-code')"
            @click="toggleAddNameSearch"
            v-model="backupLink.service.title_NL"
          >
          <core-paginated-drop-down
            v-if="serviceTypes.length && showAddNameSearch"
            :filters="serviceTypes"
            filterPropertyName="serviceTypeId"
            :item.sync="backupLink.service"
          ></core-paginated-drop-down>
        </div>
      </div>
    </div>
    <div class="px-1 d-flex align-items-center" style="width:24px">&nbsp;&nbsp;</div>
  </div>
</template>

<script>
import {clickOutside} from '@/mixins/clickOutside'

export default {
  data () {
    return {
      showAddCodeSearch: false,
      showAddNameSearch: false
    }
  },
  mixins: [clickOutside],
  props: {
    backupLink: {
      type: Object,
      required: true
    },
    wrapperClass: {
      default: 'd-flex justify-content-start move-item',
      type: String,
      required: false
    },
    serviceTypes: {
      default: () => [],
      type: Array,
      required: true
    }
  },
  methods: {
    toggleAddCodeSearch () {
      this.showAddCodeSearch = true
      if (this.showAddCodeSearch) {
        this.showAddNameSearch = false
      }
    },
    toggleAddNameSearch () {
      this.showAddNameSearch = true
      if (this.showAddNameSearch) {
        this.showAddCodeSearch = false
      }
    },
    outsideAddNameSearch () {
      this.showAddNameSearch = false
    },
    outsideAddCodeSearch () {
      this.showAddCodeSearch = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/BackupLine.vue